import { TableHorizontalScrollControlsProps } from './table-horizontal-scroller.types'
import styles from './table-horizontal-scroller.module.scss'
import cl from 'classnames'
import { useButtonProps, useIsFocused } from './table-horizontal-scroller.utils'
import { Button, IconOrderAscending } from '@touche-lts/panel-ui/dist'

const TableHorizontalScrollControlsComponent = (props: TableHorizontalScrollControlsProps) => {
  const {
    shouldRender,
    scrollLeftButtonProps,
    scrollRightButtonProps
  } = useButtonProps(props)

  const {
    isFocused,
    setOnFocus,
    setOffFocus
  } = useIsFocused(shouldRender)

  if (!shouldRender) return null

  return (
    <div
      id="table-controls"
      className={cl(styles.container, {
        [styles.containerFocused]: isFocused
      }, props.className)}
      style={props.style}
      onMouseEnter={setOnFocus}
      onMouseLeave={setOffFocus}
    >

      <Button
        preset='icon'
        {...scrollLeftButtonProps}
      >
        <IconOrderAscending
          style={{
            transform: 'rotate(-90deg)',
            fill: styles.secondaryContent
          }}
        />
      </Button>

      <Button
        preset='icon'
        {...scrollRightButtonProps}
      >
        <IconOrderAscending
          style={{
            transform: 'rotate(90deg)',
            fill: styles.secondaryContent
          }}
        />
      </Button>

    </div>
  )
}

const TableHorizontalScrollControls = TableHorizontalScrollControlsComponent
export { TableHorizontalScrollControls }
